import { render, staticRenderFns } from "./MemberCertificate.vue?vue&type=template&id=c0d7d8a0"
import script from "./MemberCertificate.vue?vue&type=script&lang=js"
export * from "./MemberCertificate.vue?vue&type=script&lang=js"
import style0 from "./MemberCertificate.vue?vue&type=style&index=0&id=c0d7d8a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports